import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LogsAuditComponent} from "./logs-audit/logs-audit.component";
import {LogsSystemComponent} from "./logs-system/logs-system.component";
import {OktaAuthGuard} from "@okta/okta-angular";


const routes: Routes = [
  { path: 'audit', component: LogsAuditComponent,  canActivate: [ OktaAuthGuard ], },
  { path: 'logs/system', component:LogsSystemComponent, },
];

@NgModule({
  imports: [ RouterModule.forChild(routes)],
  exports: [ RouterModule ],
  providers: [

   ]
})
export class LogsRoutingModule {
  static components = [ LogsAuditComponent, LogsSystemComponent];
}
